import styled from "styled-components";

export const NullCase = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  font-size: 1.5rem;
  margin: auto 0;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: ${({ direction }: { direction?: "row" | "column" }) =>
    direction ? direction : "column"};
  flex: 1;
  padding: 1rem;
  max-width: 100vw;
`;